// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__czWJa","contact-form":"Contact_contact-form__vsaAr"};